import { appVersion as envAppVersion, getCurrentCommitHash } from 'utils/environment';

export const platform = 'web';
export const host = window.location.host;
export const appVersion = envAppVersion;
export const userClient = window.navigator.userAgent;
export const appShellVersion = getCurrentCommitHash(); // no app shell on web, using the commit hash
